import {
  DEFAULT_DISPLAY_AD_BORDER_SIZE_IN_PIXELS,
  DEFAULT_DPI
} from '../helpers';
import {
  ENotice,
  ENoticeDraft,
  EOrganization,
  ESnapshotExists,
  ETemplate
} from '../types';
import { IDRequest } from '../types/notice';
import { getAdTemplateCacheID } from '../types/templates';

/**
 * The border `pullCroppedFile` adds around a display ad, in inches, or null
 * when the newspaper does not apply one. Display heights must account for it
 * because the border is part of the generated file.
 */
export const getDisplayBorderWidthInInches = (
  newspaper: ESnapshotExists<EOrganization>
): number | null =>
  newspaper.data().configureNoticePDFs?.applyBorderToDisplay
    ? DEFAULT_DISPLAY_AD_BORDER_SIZE_IN_PIXELS / DEFAULT_DPI
    : null;

/**
 * The template-specs request for a display ad. The header and footer sent
 * here must be the same ones the marginalia call renders onto the ad, or the
 * measured height will not match the generated file.
 */
export const buildTemplateSpecsRequest = ({
  newspaper,
  adTemplate,
  notice,
  columns
}: {
  newspaper: ESnapshotExists<EOrganization>;
  adTemplate: ESnapshotExists<ETemplate>;
  notice: ESnapshotExists<ENotice> | ESnapshotExists<ENoticeDraft>;
  columns: number;
}): IDRequest => {
  const { dynamicHeaders, dynamicFooter } = notice.data();
  const { displayAdHeader, displayAdFooter } = newspaper.data();

  return {
    id: getAdTemplateCacheID(adTemplate),
    noticeId: notice.id,
    downloadUrl: adTemplate.data().downloadUrl,
    columns,
    dynamicHeader: displayAdHeader ? dynamicHeaders?.[0] || null : null,
    dynamicFooter: displayAdFooter ? dynamicFooter || null : null
  };
};
